import {Injectable} from '@angular/core';

import {Observable, throwError} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {AuthorizationService} from './authorization.service';
import {Conversation} from '../models/chat';
import {environment} from '../environments/enviroment';

@Injectable({
  providedIn: 'root'
})
export class AgentDisconnectedService {

  // api
  private domain: string = `${environment.mindxbkUrl}AgentDisconnected/`;

  constructor(
    private http: HttpClient,
    private authService: AuthorizationService
  ) {

  }

  closeConversation(conversationId: string, closureReason: string): Observable<Conversation> {
    const token = localStorage.getItem('auth_req');
    if (!token) {
      console.error('❌ No se encontró token en localStorage (auth_req)');
      return throwError(() => new Error('No auth token available'));
    }

    const url = `${this.domain}Close`;
    const headers = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    });
    const body = { conversationId, closureReason };

    return this.http.patch<Conversation>(url, body, { headers });
  }
}
